import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Table,
  Dimmer,
  Loader,
  Segment,
  Item,
  Icon,
  Divider,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import { decodeSearch, encodeSearch } from '../utils/url';
import isNumber from '../utils/numbers/isNumber';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import config from '../../config';
import PageNav from '../components/PageNav';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class CustomerBookings extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    return {
      currentPage,
    };
  }
  constructor(props) {
    super(props);
    const state = CustomerBookings.getPropsToState(props);
    this.state = {
      ...state,
      count: 0,
      data: [],
      limit: 0,
      loading: true,
      offset: 0,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.fetchBookingCustomers(query);
  }
  componentWillReceiveProps(nextProps) {
    const query = decodeSearch(this.props.location.search);
    const state = CustomerBookings.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getValueName = (value, arr) => {
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  async fetchBookingCustomers(q) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page ||
      !isNumber(query.page) ||
      query.page <= 0
    ) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${this.props.params.id}/booking_customers/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-Count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setComponentState({
        count,
        data,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    this.fetchBookingCustomers(queryNew);
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  render() {
    const { data } = this.state;
    const { t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Dimmer
              inverted style={{ zIndex: 20 }}
              active={this.state.loading}
            >
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
            </Dimmer>
            {
              data && data.length > 0 ?
                <Table
                  celled
                  stackable
                >
                  <Table.Header className="mobile-hide">
                    <Table.Row>
                      <Table.HeaderCell>{`${t('Unit')}, ${t('Project')}, ${t('Booking')}`}</Table.HeaderCell>
                      <Table.HeaderCell>{t('Purchaser')}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      data.map((item, idx) => (
                        <Table.Row
                          key={idx}
                        >
                          <Table.Cell collapsing>
                            <Link
                              className="large-hide small-hide tablet-hide"
                              to={`/bookings/${item.booking.id}/`}
                              style={{
                                float: 'right',
                              }}
                            >
                              <Icon name="chevron right" />
                            </Link>
                            <Link to={`/bookings/${item.booking.id}/`}>
                              {item.booking.projectUnit.reference}, {item.booking.project.shortName}
                              <span className="mobile-hide">,&nbsp;</span>
                              <br className="large-hide" /><small>{item.booking.code}</small>
                            </Link>
                          </Table.Cell>
                          <Table.Cell>{`${item.title === 'Not Applicable' ? '' : `${item.title} `}${item.name} (${item.preferredName})`}</Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>
              : (
                <Item style={{ paddingTop: '1em' }}>
                  <Item.Content>
                    <Segment textAlign="center">
                      {
                        this.state.loading ? <Divider hidden />
                        : 'No bookings found.'
                      }
                    </Segment>
                  </Item.Content>
                </Item>
              )
            }
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <PageNav
              currentPage={this.state.currentPage}
              count={this.state.count}
              limit={this.state.limit}
              offset={this.state.offset}
              dataSize={this.state.data ? this.state.data.length : 0}
              loading={this.state.loading}
              onChange={this.handleChangePage}
              noScrollTop
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(CustomerBookings);



// WEBPACK FOOTER //
// ./src/components/CustomerBookings.jsx